import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PageSharedModule } from '@workflow/dynamic-render/page/shared/page-shared.module';
import { DynamicRenderSharedModule } from '@workflow/dynamic-render/shared/shared.module';
import { DynamicPipeModule } from '@workflow/pipe/dynamic-pipe.module';
import { ConfirmLoanGroupComponent } from './loan-group-change/confirm-loan-group.component';

const components = [ConfirmLoanGroupComponent];

@NgModule({
  declarations: [...components],
  exports: [...components],
  imports: [CommonModule, PageSharedModule, DynamicPipeModule, DynamicRenderSharedModule],
  providers: []
})
export class OlaCustomPopupModule {}
